import React from 'react';

interface ShareIconProps {
  className?: string;
}

function ShareIcon({ className }: ShareIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" className={className}>
      <path
        fill="currentColor"
        d="m15.813 6.204-5.778-6A.667.667 0 0 0 8.89.667v2.889h-.222C3.888 3.556 0 7.444 0 12.222v1.334c0 .31.218.567.519.637a.6.6 0 0 0 .147.018.69.69 0 0 0 .609-.38 7.29 7.29 0 0 1 6.558-4.053h1.056v2.889a.665.665 0 0 0 1.146.462l5.778-6a.667.667 0 0 0 0-.925"
      ></path>
    </svg>
  );
}

export default ShareIcon;
